import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { SendIcon } from '$common/icons/send'
import { SendFieldTrashIcon } from '$common/icons/send-field-trash'
import { durationLabelRenderer } from '../components/durationLabelRenderer'
import { SendFieldIconButton } from '../../icon-button'

interface Props {
  onReset: () => unknown
  duration: number
  onSend: () => unknown
}
const StyledIconButton = styled(SendFieldIconButton)`
  /* @noflip */
  margin-left: auto;
`
export function VoicePreview({ onReset, duration, onSend }: Props) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      gap="8px"
      width="100%"
      alignItems="center"
      padding="2px 8px"
      boxSizing="border-box"
      height="55px"
      sx={{
        backgroundColor: 'white',
        borderTop: '1px solid #0000001A',
      }}
    >
      <StyledIconButton onClick={onSend}>
        <SendIcon />
      </StyledIconButton>
      {durationLabelRenderer(duration)}
      <SendFieldIconButton onClick={onReset}>
        <SendFieldTrashIcon />
      </SendFieldIconButton>
    </Stack>
  )
}
